module.exports = __webpack_public_path__ + "static/img/banner_recruit_01.cea8860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/banner_recruit_01.png
// module id = tmbG
// module chunks = 10